import { Navbar } from "./Navbar";

const PageWithNavbar = ({ children }: { children: React.ReactNode }) => (
  <>
    <Navbar />
    {children}
  </>
);

export default PageWithNavbar;